import { createReducer } from "../../core/core-redux/reducer/createReducer";
import { wfs3dLayerLoadingPartialReducer } from "./wfs-3d-layer/load/wfs3dLayerLoading.reducer";
import { wfs3dLayerReloadPartialReducer } from "./wfs-3d-layer/reload/wfs3dLayerReload.reducer";
import { WFS_3D_LAYER_LOADED } from "./wfs-3d-layer/load/wfs3dLayerLoaded.action";
import { SET_WFS_3D_LAYERS_VISIBILITY } from "./wfs-3d-layer/visibility/setWfs3dLayersVisibility.action";
import { wfs3dLayerVisibilityPartialReducer } from "./wfs-3d-layer/visibility/wfs3dLayersVisibility.reducer";
import { wfs3dLayerCountPartialReducer } from "./wfs-3d-layer/count/wfs3dLayerCount.reducer";
import { STORE_WFS_FEATURE_COUNT } from "./wfs-3d-layer/count/storeWfsFeatureCount.action";
import { wfs3dFeatureCountPartialReducer } from "./wfs-3d-layer/count/wfs3dFeatureCount.reducer";
import { SET_WFS_3D_LAYER_COUNT } from "./wfs-3d-layer/count/setWfs3dLayerCount.action";
import { ADJUST_HEIGHT } from "./wfs-3d-layer/height/adjustHeight.action";
import { wfs3dFeatureHeightPartialReducer } from "./wfs-3d-layer/height/wfs3dFeatureHeight.reducer";
import { UPDATE_WFS_FILTER } from "./wfs-3d-layer/filter/updateWfsFilter.action";
import { wfs3dFeatureFilterPartialReducer } from "./wfs-3d-layer/filter/wfs3dFeatureFilter.reducer";
import { SAVE_WFS_3D_LAYERS } from "./wfs-3d-layer/save/saveWfs3dLayerAction";
import { wfs3dLayerPartialReducer } from "./wfs-3d-layer/save/wfs3dLayer.reducer";
import { Wfs3dLayer } from "../types";
import { wfs3dLayerLoadedPartialReducer } from "./wfs-3d-layer/load/wfs3dLayerLoaded.reducer";
import { WFS_3D_LAYER_LOADING } from "./wfs-3d-layer/load/wfs3dLayerLoading.action";
import { WFS_3D_LAYER_RELOAD } from "./wfs-3d-layer/reload/wfs3dLayerReload.action";

export interface Wfs3dLayersState {
    layers: Wfs3dLayer[];
    layerCount: any;
    layersFeatureCount: any;
    visibleLayers: any[];
    visibleGroup?: any;
    loading: boolean;
    allLayersCounted: boolean;
}

export const wfs3dLayersReducer = createReducer<Wfs3dLayersState>(
    {
        layers: [],
        layerCount: {},
        layersFeatureCount: {},
        visibleGroup: undefined,
        visibleLayers: [],
        loading: false,
        allLayersCounted: false,
    },
    {
        [SAVE_WFS_3D_LAYERS]: wfs3dLayerPartialReducer,
        [WFS_3D_LAYER_LOADED]: wfs3dLayerLoadedPartialReducer,
        [WFS_3D_LAYER_LOADING]: wfs3dLayerLoadingPartialReducer,
        [WFS_3D_LAYER_RELOAD]: wfs3dLayerReloadPartialReducer,
        [SET_WFS_3D_LAYERS_VISIBILITY]: wfs3dLayerVisibilityPartialReducer,
        [SET_WFS_3D_LAYER_COUNT]: wfs3dLayerCountPartialReducer,
        [STORE_WFS_FEATURE_COUNT]: wfs3dFeatureCountPartialReducer,
        [ADJUST_HEIGHT]: wfs3dFeatureHeightPartialReducer,
        [UPDATE_WFS_FILTER]: wfs3dFeatureFilterPartialReducer,
    }
);
